import React, { FC } from "react";
import ThousandsSeparator from "../../../utils/thousands-separator";
import { roundFloat } from "../../../utils/round-float";

type Props = {
  ability: any;
  isMarket?: boolean;
  bonus?: React.ReactNode | number;
  isPercentage?: boolean;
};

export const CalculateTroopAbility: FC<Props> = ({ ability, isMarket, bonus, isPercentage }) => {
  let abilityNumber = ThousandsSeparator(ability?.Value);

  if (ability?.Name === "Heal" && !isMarket) {
    const checkedBonus = typeof bonus === "number" ? bonus : 0;
    abilityNumber = ThousandsSeparator(
      roundFloat(
        ability?.Value + (parseFloat(ability?.Value) * checkedBonus) / 100
      )?.toString()
    );
  }

  return (
    <>
      <b>{`${ability?.Name} (${isPercentage ? "%" : "+"}${abilityNumber})`}</b>
      <br />
      <small>{ability.Comment}</small>
    </>
  );
};

export default CalculateTroopAbility;


